/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';
import { createBlock } from '@wordpress/blocks';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType(metadata.name, {
	edit: Edit,
	// save: () => {
	// 	// Dynamic block: save function is not needed
	// 	return null;
	// },
	transforms: {
		from: [
			{
				type: 'block',
				blocks: ['core/legacy-widget'],
				isMatch: ({ idBase, instance }) => {
					if (!instance?.raw) {
						// Can't transform if raw instance is not shown in REST API.
						return false;
					}
					return idBase === 'pix_small_search';
				},
				transform: ({ instance }) => {
					const headingBlock = createBlock('core/heading', {
						content: instance.raw.title,
						level: 5, // Set the heading level to H5
						style: {
							typography: {
								fontWeight: '600'
							}
						},
						className: 'pix-sm-margin'
					});

					const searchBlock = createBlock('pixfort-core/pix-small-search');

					return [headingBlock, searchBlock];
				}
			}
		]
	}
});
